'use client';

import { FC } from 'react';

import { InviteStatus } from 'types';

interface IMemberTag {
  label: string;
  type: InviteStatus;
  wrapperClassnames?: string;
}

export const getStatusColor = (status: InviteStatus) => {
  switch (status) {
    case 'HelpReactionNode':
      return 'bg-lime-300 text-lime-900';
    case 'ConnectNode':
      return 'bg-brand-100 text-brand-700';
    case 'HelpNode':
      return 'bg-warning-100 text-warning-700';
    case 'WorkedWithRequestNode':
    default:
      return 'bg-success-100 text-black';
  }
};


export const MemberTag: FC<IMemberTag> = (props) => {
  const { label, type, wrapperClassnames } = props;

  return (
    <div
      className={`rounded-full px-md py-xxs text-[12px]/[18px] flex items-center ${getStatusColor(
        type
      )} ${wrapperClassnames}`}
    >
      {label}
    </div>
  );
};
